import { FileText } from "lucide-react";
import { Window, Tag, seg } from "./primitives";

const BLOCKS = [
  ["HOOK", "Thinking about selling your home this spring?"],
  ["PROBLEM", "Pricing it right and finding serious buyers isn't easy."],
  ["SOLUTION", "Let a local expert market your home and handle the details."],
  ["CALL TO ACTION", "Get your free home valuation today."],
];
const TOTAL = BLOCKS.reduce((n, [, t]) => n + t.length, 0);

export function StageScript({ p }) {
  let remaining = Math.floor(seg(p, 0.02, 0.8) * TOTAL);
  let caretPlaced = false;
  return (
    <Window title="example_ad-script_realtor_v3.doc" right={<Tag><FileText className="h-3 w-3" /> 9:16 · 0:28</Tag>}>
      <div className="h-full overflow-hidden px-6 py-6 sm:px-10 sm:py-8">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400">Example · Real Estate Agent · Spot #1</p>
        <h4 className="mt-2 text-lg sm:text-2xl font-semibold tracking-tight text-white">"What's Your Home Worth?"</h4>
        <div className="mt-5 space-y-4 sm:mt-7 sm:space-y-5">
          {BLOCKS.map(([label, text]) => {
            const shown = text.slice(0, Math.max(0, remaining));
            remaining -= text.length;
            const typing = !caretPlaced && shown.length < text.length;
            if (typing) caretPlaced = true;
            return (
              <div key={label} className="grid grid-cols-[92px_1fr] gap-3 sm:grid-cols-[130px_1fr]">
                <p className={`pt-1 font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.18em] transition-colors duration-300 ${shown ? "text-electric" : "text-slate-600"}`}>{label}</p>
                <p className="min-h-[1.5em] text-[15px] sm:text-xl font-medium leading-snug text-white">
                  {shown && <>&ldquo;{shown}{shown.length === text.length && <>&rdquo;</>}</>}
                  {typing && <span className="ml-0.5 inline-block h-[1em] w-[2px] translate-y-[3px] animate-blink bg-cyan-300" />}
                </p>
              </div>
            );
          })}
        </div>
        <div className="mt-6 flex flex-wrap gap-2" style={{ opacity: seg(p, 0.8, 0.95) }}>
          <Tag className="!text-emerald-300 !border-emerald-400/30">Script approved</Tag>
          <Tag>Next → Film</Tag>
        </div>
      </div>
    </Window>
  );
}
